module.exports = __webpack_public_path__ + "img/icon-facebook.8ce35aee.svg";